import React, { useState } from 'react'
import ProjectContentsSearch from './ProjectContentsSearch'
import ProjectContents from './ProjectContents'
import ProjectEmpty from './ProjectEmpty'

const ProjectContainer = ({
  project_path,
  contentPath,
  initialContents,
  new_project_content_path,
  new_project_content_path_for_pdf,
  new_project_content_path_for_images,
  new_project_content_path_for_audio,
}) => {
  const [contents, setContents] = useState(initialContents)

  const handleSearchResults = (newContents) => {
    if (newContents) {
      setContents(newContents)
    }
  }

  const reloadContents = (content) => {
    setContents(initialContents.filter((c) => c.id !== content.id))
  }

  return (
    <>
      {contents.length > 0 ? (
        <div className="flex flex-col gap-4">
          <ProjectContentsSearch
            project_path={project_path}
            onSearchResults={handleSearchResults}
          />
          <ProjectContents
            project_path={project_path}
            contentPath={contentPath}
            contents={contents}
            onSearchResults={handleSearchResults}
            onContentDelete={reloadContents}
          />
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <ProjectEmpty
            new_project_content_path={new_project_content_path}
            new_project_content_path_for_pdf={new_project_content_path_for_pdf}
            new_project_content_path_for_images={new_project_content_path_for_images}
            new_project_content_path_for_audio={new_project_content_path_for_audio}
          />
        </div>
      )
      }
    </>
  )
}

export default ProjectContainer 